import { useLanguage } from "../../context/LanguageContext";
import { useState, useEffect } from "react";
 

export const useTranslation = () => {
  const { language } = useLanguage();
  const [translatedContent, setTranslatedContent] = useState({});
  //console.log("🌐 Selected language:", language);

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const [navMod, levelMod] = await Promise.all([
          import(`../translations/${language}-translations.js`),
          import(`../translations/${language}-translateLevelContentData.js`)
        ]);

        const rawNav = navMod.default || navMod;
        const rawLevel = levelMod.default || levelMod;

        const nav = rawNav?.translations?.[language] || {};
        const level = rawLevel.translateLevelContentData?.[language] || {};

        setTranslatedContent({
          ...nav,
          ...(level.level || {}),
          ...(level.description || {}),
          ...(level.contentItems || {}),
          ...(level.videos || {}),
          ...(level.docs || {}),
          ...(level.utils || {})
        });
      } catch (err) {
        //console.warn(`Failed to load language "${language}", falling back to English.`, err);
        const [navMod, levelMod] = await Promise.all([
          import(`../translations/en-translations.js`),
          import(`../translations/en-translateLevelContentData.js`)
        ]);

        const rawNav = navMod.default || navMod;
        const rawLevel = levelMod.default || levelMod;

        const nav = rawNav?.translations?.en || {};
        const level = rawLevel.translateLevelContentData?.en || {};

        setTranslatedContent({
          ...nav,
          ...(level.level || {}),
          ...(level.description || {}),
          ...(level.contentItems || {}),
          ...(level.videos || {}),
          ...(level.docs || {}),
          ...(level.utils || {})
        });
      }
    };

    loadTranslations();
  }, [language]);

  useEffect(() => {
  document.body.setAttribute("data-lang", language);
}, [language]);

  return (key) => translatedContent[key] || key;
};
